import React from 'react';
import { agencyInfo } from '../mock';
import { Mail, Instagram, Phone } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-black text-white py-16">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid md:grid-cols-3 gap-12 mb-12">
          {/* Brand */}
          <div>
            <div className="flex items-center gap-3 mb-4">
              <img 
                src="/cortexa-logo.jpeg" 
                alt="Cortexa" 
                className="w-10 h-10 object-contain"
              />
              <span className="text-2xl font-bold">{agencyInfo.name}</span>
            </div>
            <p className="text-white/60 leading-relaxed font-light">
              Building intelligent marketing systems that work 24/7.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-semibold mb-4 uppercase tracking-wider text-sm">Quick Links</h4>
            <ul className="space-y-2">
              <li>
                <a href="/portfolio" className="text-white/60 hover:text-white transition-colors font-light">
                  Portfolio
                </a>
              </li>
              <li>
                <a href="#contact" className="text-white/60 hover:text-white transition-colors font-light">
                  Contact
                </a>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-semibold mb-4 uppercase tracking-wider text-sm">Connect</h4>
            <ul className="space-y-3">
              <li>
                <a href={`mailto:${agencyInfo.email}`} className="flex items-center gap-2 text-white/60 hover:text-white transition-colors font-light">
                  <Mail className="w-4 h-4" />
                  {agencyInfo.email}
                </a>
              </li>
              <li>
                <a href={`https://instagram.com/${agencyInfo.instagram.replace('@', '')}`} target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 text-white/60 hover:text-white transition-colors font-light">
                  <Instagram className="w-4 h-4" />
                  {agencyInfo.instagram}
                </a>
              </li>
              <li>
                <a href={`https://wa.me/${agencyInfo.whatsapp.replace(/[^0-9]/g, '')}`} target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 text-white/60 hover:text-white transition-colors font-light">
                  <Phone className="w-4 h-4" />
                  {agencyInfo.whatsapp}
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom */}
        <div className="pt-8 border-t border-white/10 text-center text-white/60 font-light">
          <p>&copy; {new Date().getFullYear()} {agencyInfo.name}. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;